import React from "react";
import { CustomTextField } from "../formsComponents";
import {
  CircularProgress,
  Autocomplete as MUIAutoComplete,
} from "@mui/material";

export const AutoComplete: React.FC<{
  value: any;
  label?: string;
  placeholder?: string;
  helperText?: string;
  disabled?: boolean;
  options: { label: string; value: string }[];
  fullWidth?: boolean;
  error?: boolean;
  onChange?: (value: any) => void;
  onFocus?: () => void;
  loading?: boolean;
}> = (props) => {
  const {
    value,
    label,
    placeholder,
    helperText,
    options,
    onChange,
    disabled = false,
    fullWidth,
    error = false,
    onFocus,
    loading,
  } = props;

  return (
    <>
      <MUIAutoComplete
        sx={{
          width: fullWidth ? "100%" : "auto",
          ".MuiOutlinedInput-root": {
            paddingTop: "2px",
            paddingBottom: "2px",
            fontSize: "0.8rem",
            color: "rgb(38, 38, 38)",
          },
        }}
        key={options.length}
        value={value ? options.find((x) => x.value === value) : null}
        options={[...options]}
        // groupBy={(option) => option.}
        autoHighlight
        getOptionLabel={(option) => option.label}
        onChange={(e, newValue) => {
          if (onChange) {
            if (newValue) {
              onChange(newValue.value);
            } else {
              onChange(null);
            }
          }
        }}
        onFocus={onFocus}
        disabled={disabled}
        openOnFocus={options.length > 0}
        renderInput={(params) => (
          <CustomTextField
            {...params}
            value={value}
            label={label}
            InputLabelProps={{ shrink: true }}
            fullWidth
            placeholder={placeholder}
            disabled={disabled}
            helperText={helperText}
            error={error}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading && <CircularProgress color="inherit" size={20} />}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </>
  );
};
